import { render, staticRenderFns } from "./DeskMynt.vue?vue&type=template&id=c1a6c5ee"
import script from "./DeskMynt.vue?vue&type=script&lang=js"
export * from "./DeskMynt.vue?vue&type=script&lang=js"
import style0 from "./DeskMynt.vue?vue&type=style&index=0&id=c1a6c5ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports